import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../common/css/redundant.css';
import {useInterval, parse_metrics_body, strArraySortAsc, saveIfChange, getMetricProperty} from '../../common/app_common.js';
import {getApiDataQuery, getApiDataQueryRange} from '../../common/fetch_api/data';
import {getApiEdgeIdMetrics, getApiEdgeIdAlertStatusSummary} from '../../common/fetch_api/edge';
import {TitleDetail, TermRefresh, CheckEdgeMetric} from '../../common/component_common.js';
import Collapse from 'react-bootstrap/Collapse';
import {checkApiDataResult, getStartEndStep, makeResultData, makeStlBitrateChartData, updateStlBitrateChartData,
        ChartTime, DisplayMaxMinValue, timeTextChange, stlBitrateValuesTimeDisp
        } from './monitoring/monitoring_common.js';
import {stlChartOption} from './monitoring/chartsOptions';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { StatusAlertModal } from '../../common/modal_common.js';
import {TermRefreshContext} from '../../pages/sites_list';
import {
    BsChevronDown,
    BsChevronRight,
    BsClock,
    BsBoxArrowInRight,
    BsBoxArrowRight,
    BsDiagram2Fill,
    BsServer,
    BsSignMergeRight,
    BsGear,
  } from "react-icons/bs";

  const typeIconComponentMap = {
    input: BsBoxArrowInRight,
    output: BsBoxArrowRight,
    port: BsSignMergeRight,
    mode: BsGear,
    time: BsClock,
    module: BsDiagram2Fill,
    host: BsServer,
  };

const RedundantMonitoring = ({setPageName, siteInfo, edgeInfo}) =>
{
    // console.log('redundant edgeInfo', edgeInfo);
    let termInit = sessionStorage.getItem('term');
    const [term, setTerm] = useState(termInit ?? '1');
    sessionStorage.setItem('term', term);

    let refreshInit = sessionStorage.getItem('refresh');
    const [refresh, setRefresh] = useState(refreshInit ?? 5000);
    sessionStorage.setItem('refresh', refresh);

    if(!siteInfo)
    {
        siteInfo = JSON.parse(sessionStorage.getItem('siteInfo'));
    }

    if(!edgeInfo)
    {
        edgeInfo = JSON.parse(sessionStorage.getItem('edgeInfo'));
    }

    const [isStop, setIsStop] = useState(false);
    const [reload, setReload] = useState(false);
    const [isCalendar, setIsCalendar] = useState(false);

    const [metricsObj, setMetricsObj] = useState(null);

    const [update, setUpdate] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        Promise.resolve(getApiEdgeIdMetrics(edgeInfo.id))
        .then(data =>
        {
            let parseBody = parse_metrics_body(data);
            setMetricsObj(parseBody.metrics);
        });
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
            <div className="d-flex flex-wrap position-relative">
                {edgeInfo.id && <div className="no-signal-position"><CheckEdgeMetric edgeId={edgeInfo.id} /></div>}
                <TitleDetail setPageName={setPageName} siteName={siteInfo.name} edgeTitle={edgeInfo.name} />
                <TermRefresh setTerm={setTerm} term={term} setRefresh={setRefresh} refresh={refresh} setIsStop={setIsStop} isStop={isStop} reload={reload} setReload={setReload} setIsCalendar={setIsCalendar} isCalendar={isCalendar}/>
            </div>
            <div className="d-flex flex-column redundant-page mt-2">
                {metricsObj && <RedundantMonitoringStatus metricsObj={metricsObj} pageName={'mainPage'} edgeId={edgeInfo.id}/>}
                <div className="d-flex flex-wrap">
                    <RedundantVersionInfo edgeId={edgeInfo.id} pageName={'mainPage'}/>
                    <RedundantCpuUsage edgeId={edgeInfo.id} pageName={'mainPage'}/>
                    <RedundantMemUsage edgeId={edgeInfo.id} pageName={'mainPage'}/>
                    <RedundantDiskUsage edgeId={edgeInfo.id} pageName={'mainPage'}/>
                </div>
                {metricsObj && <RedundantInputGroups edgeId={edgeInfo.id} metricsObj={metricsObj}/>}
            </div>
        </TermRefreshContext.Provider>
    )
}

export default RedundantMonitoring;

export const RedundantInputGroups = ({edgeId, metricsObj}) =>
{
    const [update, setUpdate] = useState(false);
    const [inputIdxList, setInputIdxList] = useState([]);
    const [openMap, setOpenMap] = useState({});
    const [gatewayStatByIdx, setGatewayStatByIdx] = useState({});
    const [inputInfoByIdx, setInputInfoByIdx] = useState({});
    const [plpNumByIdx, setPlpNumByIdx] = useState({});
    const [plpBitrateByIdx, setPlpBitrateByIdx] = useState({});
    const [plpErrByIdx, setPlpErrByIdx] = useState({});

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.resolve(getApiDataQuery(`dcr_in_info{id="${edgeId}"}`, nowTimestamp))
        .then((data) =>
        {
            // console.log('redundant input info', data);
            if( !checkApiDataResult(data) && data.data && data.data.result )
            {
                const idxArr = data.data.result
                    .map(item => item.metric.idx)
                    .sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                const infoByIdx = {};
                data.data.result.forEach((item) =>
                {
                    const idx = item.metric.idx;
                    infoByIdx[idx] = {
                        name: item.metric.name ?? '',
                        row: item.metric.row ?? '',
                        col: item.metric.col ?? '',
                        fec: item.metric.fec ?? ''
                    };
                });

                setInputIdxList(idxArr);
                setInputInfoByIdx(infoByIdx);

                setOpenMap(prev =>
                {
                    const next = {...prev};
                    idxArr.forEach((idx) =>
                    {
                        if (typeof next[idx] === 'undefined')
                        {
                            next[idx] = true;
                        }
                    });
                    return next;
                });
            }
            else
            {
                setInputIdxList([]);
                setInputInfoByIdx({});
                setOpenMap({});
            }
        });

        Promise.resolve(getApiDataQuery(`dcr_in_stat{id="${edgeId}"}`, nowTimestamp))
        .then((data) =>
        {
            // console.log('redundant input stat', data);
            if (checkApiDataResult(data) || !data?.data?.result) return;
            const byIdx = {};
            data.data.result.forEach((item) =>
            {
                const idx = item.metric.idx;
                const component = item.metric.component;
                const val = item.value?.[1] ?? '';
                if (!byIdx[idx]) byIdx[idx] = {};
                byIdx[idx][component] = val;
            });
            setGatewayStatByIdx(byIdx);
        });

        Promise.all([
            getApiDataQuery(`dcr_stat_num_plp{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcr_stat_plp_bitrate{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcr_stat_plp_err{id="${edgeId}"}`, nowTimestamp)
        ])
        .then(([data1, data2, data3]) =>
        {
            if (checkApiDataResult(data1) || !data1?.data?.result) return;
            const numByIdx = {};
            data1.data.result.forEach((item) =>
            {
                const idx = item.metric.idx;
                const n = parseInt(item.value?.[1], 10);
                numByIdx[idx] = isNaN(n) ? 0 : n;
            });
            setPlpNumByIdx(numByIdx);

            const bitrateByIdx = {};
            if (!checkApiDataResult(data2) && data2?.data?.result) {
                data2.data.result.forEach((item) =>
                {
                    const idx = item.metric.idx;
                    const plp = item.metric.plp ?? '';
                    const bps = parseInt(item.value?.[1], 10) || 0;
                    const mbps = (bps / 1e6).toFixed(3);
                    if (!bitrateByIdx[idx]) bitrateByIdx[idx] = {};
                    bitrateByIdx[idx][plp] = mbps;
                });
            }
            setPlpBitrateByIdx(bitrateByIdx);

            const errByIdx = {};
            if (!checkApiDataResult(data3) && data3?.data?.result) {
                data3.data.result.forEach((item) =>
                {
                    const idx = item.metric.idx;
                    const plp = item.metric.plp ?? '';
                    const val = item.value?.[1] ?? '';
                    if (!errByIdx[idx]) errByIdx[idx] = {};
                    errByIdx[idx][plp] = val;
                });
            }
            setPlpErrByIdx(errByIdx);
        });

    }, [edgeId, update]);

    useEffect(() =>
    {
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    const toggleOpen = (idx) =>
    {
        setOpenMap(prev => ({...prev, [idx]: !prev[idx]}));
    };

    const getSignalStatusClass = (val) => (val === '1' ? 'danger' : (val === '0' ? 'good' : ''));
    const getPlpStatusClass = (val) => (val === '1' ? 'danger' : (val === '0' ? 'good' : ''));

    const renderGatewaySection = (idx, selected) =>
    {
        const stat = gatewayStatByIdx[idx] || {};
        const info = inputInfoByIdx[idx] || {};
        const stlVal = stat.stl ?? '';
        const llsVal = stat.lls ?? '';
        const lmtVal = stat.lmt ?? '';
        const crcVal = stat.crc ?? '';
        const rtpVal = stat.rtp ?? '';
        const rtpCnt = stat.rtp_cnt ?? '';
        const colRowLabel = info.fec === '0' ? '' : ([info.row, info.col].every(Boolean) ? `(${info.col} X ${info.row})` : '');

        return (
            <div className={`section gateway-section${selected ? ' selected' : ''}`}>
                <div className="d-flex justify-content-center">
                    <div className="title">{info.name || '-'}</div>
                    <div className="label" style={{marginTop: '2px'}}>{colRowLabel}</div>
                </div>
                <div className="d-flex justify-content-around p-2">
                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex">
                            <div className={`signal-status ${getSignalStatusClass(stlVal)}`}></div>
                            <div className="signal-name">STL Missing</div>
                        </div>
                        <div className="d-flex">
                            <div className={`signal-status ${getSignalStatusClass(llsVal)}`}></div>
                            <div className="signal-name">LLS Missing</div>
                        </div>
                        <div className="d-flex">
                            <div className={`signal-status ${getSignalStatusClass(lmtVal)}`}></div>
                            <div className="signal-name">LMT Missing</div>
                        </div>
                        <div className="d-flex">
                            <div className={`signal-status ${getSignalStatusClass(crcVal)}`}></div>
                            <div className="signal-name">CRC Invalid</div>
                        </div>
                        <div className="d-flex">
                            <div className={`signal-status ${getSignalStatusClass(rtpVal)}`}></div>
                            <div className="signal-name d-flex">
                                <div>RTP Loss</div>
                                <div className="rtp-value ms-auto">{rtpCnt}</div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-2 plp-area">
                        {Array.from({ length: plpNumByIdx[idx] || 0 }, (_, i) => String(i)).map((plpId) =>
                        {
                            const bitrate = (plpBitrateByIdx[idx] || {})[plpId] ?? '-';
                            const errVal = (plpErrByIdx[idx] || {})[plpId] ?? '';
                            const plpStatusClass = getPlpStatusClass(errVal);
                            return (
                                <div className="d-flex" key={plpId}>
                                    <div className="plp-name d-flex align-items-center">
                                        <span className="icon-name ms-1">PLP</span>
                                        <span className="id-title ms-1">ID</span>
                                        <span className="id-no ms-1">{plpId}</span>
                                        <span className="ms-auto text-end">
                                            <span className="bitrate ms-1">{bitrate}</span>
                                            <span className="bit-unit">Mbps</span>
                                        </span>
                                    </div>
                                    <div className={`plp-status ${plpStatusClass}`}></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };

    const selPortValue = metricsObj?.dcr_sel_port?.[0]?.value ?? '0';
    const selPortIndex = parseInt(selPortValue, 10);

    return (
        <>
            {inputIdxList.map((idx, index) =>
            {
                const isOpen = !!openMap[idx];
                const collapseId = `redundantInputTab-${idx}`;
                const showOutput = index === selPortIndex;

                return (
                    <React.Fragment key={idx}>
                        <div
                            className="d-flex div-title"
                            onClick={() => toggleOpen(idx)}
                            aria-controls={collapseId}
                            aria-expanded={isOpen}
                        >
                            {isOpen ? <BsChevronRight/> : <BsChevronDown/>}
                            {`Input ${index + 1}`}
                        </div>
                        <Collapse in={isOpen}>
                            <div id={collapseId}>
                                <div className="d-flex redundant-main-area flex-wrap">
                                    <RedundantInputBitrate edgeId={edgeId} inputIdx={idx} selected={showOutput} />
                                    {renderGatewaySection(idx, showOutput)}
                                    {showOutput && <RedundantOutputBitrate edgeId={edgeId} selected={showOutput}/>}
                                </div>
                            </div>
                        </Collapse>
                    </React.Fragment>
                );
            })}
        </>
    );
}

export const RedundantInputGroupsForDashBoard = ({edgeId, metricsObj, pageName}) =>
{
    const [update, setUpdate] = useState(false);
    const [inputIdxList, setInputIdxList] = useState([]);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.resolve(getApiDataQuery(`dcr_in_info{id="${edgeId}"}`, nowTimestamp))
        .then((data) =>
        {
            if( !checkApiDataResult(data) && data.data && data.data.result )
            {
                const idxArr = data.data.result
                    .map(item => item.metric.idx)
                    .sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
                setInputIdxList(idxArr);
            }
            else
            {
                setInputIdxList([]);
            }
        });

    }, [edgeId, update]);

    useEffect(() =>
    {
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    const selPortValue = metricsObj?.dcr_sel_port?.[0]?.value ?? '0';
    const selPortIndex = parseInt(selPortValue, 10);

    return (
        <>
            {inputIdxList.map((idx, index) =>
            {
                const showOutput = index === selPortIndex;

                return (
                    <React.Fragment key={idx}>
                        <div className="d-flex div-title">
                            {`Input ${index + 1}`}
                        </div>
                        <div className="d-flex redundant-main-area flex-wrap">
                            <RedundantInputBitrate edgeId={edgeId} inputIdx={idx} pageName={pageName} selected={showOutput} />
                            {showOutput && <RedundantOutputBitrate edgeId={edgeId} pageName={pageName} selected={showOutput}/>}
                        </div>
                    </React.Fragment>
                );
            })}
        </>
    );
}

export const RedundantMonitoringStatus = ({pageName, edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    const runUpdate = () => {
        setUpdate(prev => !prev);
    };

    useEffect(() =>
    {
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);
    
    const [statusData, setStatusData] = useState([]);
    const [modalStatusAlert, setModalStatusAlert] = useState(false);
    const [selectedAlertFilter, setSelectedAlertFilter] = useState('');
    const [selectedAlertName, setSelectedAlertName] = useState('');
    
    const closeModalStatusAlert = () => setModalStatusAlert(false);

    const showModalStatusAlert = (alertFilter, alertName) => {
        setSelectedAlertFilter(alertFilter);
        setSelectedAlertName(alertName);
        setModalStatusAlert(true);
    };

    useEffect(() => {
        getApiEdgeIdAlertStatusSummary(edgeId)
        .then(data => {
            setStatusData(Array.isArray(data) ? data : []);
            // console.log('redundant alert status summary', data);
        });
    }, [update]);

    // group별로 데이터 묶기
    const grouped = {};
    (statusData || []).forEach(item => {
        if (!grouped[item.group]) grouped[item.group] = [];
        grouped[item.group].push(item);
    });

    return (
        <div className="d-flex flex-wrap edge-top-status">
            {Object.keys(grouped).map(groupKey => {
                const items = grouped[groupKey].sort((a, b) => a.index - b.index);
                return (
                    <div className="section" key={groupKey}>
                        
                        {items.map((item, idx) => {
                            const IconComponent = typeIconComponentMap[item.type];
                            // 마지막 index인지 판별
                            const isLast = idx === items.length - 1;
                            // className 조건
                            const boxClass =
                                "status-box " +
                                (isLast
                                    ? (pageName === "subPage" ? "me-3" : "")
                                    : (pageName === "subPage" ? "me-1" : "me-2"));
                            return (
                                <div className={boxClass} key={`${groupKey}-${item.type}-${idx}`}
                                    style={item.resolvedCount !== 0 ? { cursor: "pointer" } : undefined}
                                    onClick={
                                        item.resolvedCount !== 0
                                            ? () => showModalStatusAlert(item.alertFilter, item.value)
                                            : undefined
                                    }
                                >
                                    <div className="status-header position-relative">
                                        {item.resolvedCount !== 0 && (
                                            <span className="badge-dot bg-warning"></span>
                                        )}
                                        {IconComponent && <IconComponent />}
                                    </div>
                                    <div className={
                                            "status-body" +
                                            (item.value !== "" ? ` bg-${item.status}` : "")
                                        }
                                    >
                                        {item.value}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        {modalStatusAlert && <StatusAlertModal edgeId={edgeId} alertName={selectedAlertName} alertFilter={selectedAlertFilter} show={modalStatusAlert} handleClose={closeModalStatusAlert} />}
        </div>
    )
}

export const RedundantVersionInfo = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [version, setVersion] = useState('-');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.resolve(getApiDataQuery(`dcr_version_info{id="${edgeId}"}`, nowTimestamp))
        .then((data) =>
        {
            if( !checkApiDataResult(data) )
            {
                const middleware = data.data.result[0].metric.middleware;
                setVersion(middleware != null && middleware !== '' ? middleware : '-');
            }
            else
            {
                setVersion('-');
            }
        });
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <>
            <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6':''}`}>
                <div className="section">
                    <div className="section-title">Version</div>
                    <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{version}</div>
                </div>
            </div>
        </>
    )
}

export const RedundantCpuUsage = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcr_system_usage{type="cpu", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const cpuUsage = data.data.result[0].value[1];
                setValue(cpuUsage != null && cpuUsage !== '' ? parseFloat(cpuUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('0');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">CPU Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const RedundantMemUsage = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcr_system_usage{type="mem", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const memUsage = data.data.result[0].value[1];
                setValue(memUsage != null && memUsage !== '' ? parseFloat(memUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">MEM Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const RedundantDiskUsage = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcr_system_usage{type="disk", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const diskUsage = data.data.result[0].value[1];
                setValue(diskUsage != null && diskUsage !== '' ? parseFloat(diskUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('0');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">DISK Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const RedundantInputBitrate = ({edgeId, inputIdx, pageName, selected}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(stlChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        stlMb: '00.00',
        fecMb: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);

        const idxFilter = inputIdx != null ? `, idx="${inputIdx}"` : '';
        
        Promise.all([
            getApiDataQueryRange(`dcr_in_bitrate{id="${edgeId}"${idxFilter}}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`dcr_in_fec_bitrate{id="${edgeId}"${idxFilter}}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let stlResult = data1.data.result[0].values;
                let fecResult = data2.data.result[0].values;

                let stlValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, stlResult);
                let fecValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, fecResult);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = stlValues[stlValues.length - 1][0];

                    let data = makeStlBitrateChartData(stlValues, fecValues);

                    setChartOptions({...chartOptions, series: [{data: data.fecDataArr},{data: data.stlDataArr}]});
                }
                else if(!setInit.current)
                {
                    updateStlBitrateChartData(chartRef.current.chart,  stlValues, fecValues, chartLastTime.current);

                    chartLastTime.current = stlValues[stlValues.length - 1][0];
                }

                setDisplayValues(stlBitrateValuesTimeDisp(stlValues, fecValues));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className={`section input-bitrate${selected ? ' selected' : ''}`}>
                <div className="section-title">Input Bitrate</div>
                <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar stl"></span>STL</div>
                        <div className="value-label lg">{displayValues.stlMb}Mbps</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar sub-c1"></span>STL with FEC</div>
                        <div className="value-label lg">{displayValues.fecMb}Mbps</div>
                    </div>
                    <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
                    <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
                    <DisplayMaxMinValue label="(STL)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'Mbps'} />
                </div>
            </div>
        </div>
    )
}

export const RedundantOutputBitrate = ({edgeId, pageName, selected}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(stlChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        stlMb: '00.00',
        fecMb: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`dcr_out_bitrate{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`dcr_out_fec_bitrate{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let stlResult = data1.data.result[0].values;
                let fecResult = data2.data.result[0].values;

                let stlValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, stlResult);
                let fecValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, fecResult);

                
                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = stlValues[stlValues.length - 1][0];

                    let data = makeStlBitrateChartData(stlValues, fecValues);

                    setChartOptions({...chartOptions, series: [{data: data.fecDataArr},{data: data.stlDataArr}]});
                }
                else if(!setInit.current)
                {
                    updateStlBitrateChartData(chartRef.current.chart,  stlValues, fecValues, chartLastTime.current);

                    chartLastTime.current = stlValues[stlValues.length - 1][0];
                }

                setDisplayValues(stlBitrateValuesTimeDisp(stlValues, fecValues));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className={`section output-bitrate${selected ? ' selected' : ''}`}>
                <div className="section-title">Output Bitrate</div>
                <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar stl"></span>STL</div>
                        <div className="value-label lg">{displayValues.stlMb}Mbps</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar sub-c1"></span>STL with FEC</div>
                        <div className="value-label lg">{displayValues.fecMb}Mbps</div>
                    </div>
                    <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
                    <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
                    <DisplayMaxMinValue label="(STL)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'Mbps'} />
                </div>
            </div>
        </div>
    )
}

